export class InboundBandwidthFulfillmentMetricsCollector {
    started = false;
    bandwidthFulfillmentMap = new Map();
    start() {
        if (!this.started) {
            this.resetCollection();
            this.started = true;
        }
    }
    stop() {
        this.started = false;
    }
    resetCollection() {
        this.bandwidthFulfillmentMap = new Map();
    }
    outputMetrics() {
        if (!this.started)
            return [];
        const metrics = [];
        for (const [sfuAddr, values] of this.bandwidthFulfillmentMap) {
            const { consumers, totalConsumers, expectedPixelRate, receivedPixelRate } = { ...values };
            metrics.push({
                name: "inboundBandwidthFulfillment",
                values: {
                    sfuAddr,
                    consumers,
                    totalConsumers,
                    expectedPixelRate,
                    receivedPixelRate,
                },
            });
        }
        return metrics;
    }
    onInboundBandwidthFulfillment(sfuAddr, bandwidthFulfillment) {
        this.bandwidthFulfillmentMap.set(sfuAddr, bandwidthFulfillment);
    }
}
//# sourceMappingURL=InboundBandwithFulfillmentMetricsCollector.js.map